import clsx from "clsx";

import { ColorSwatch, TextTooltip } from "@transfr-inc/dashboard-components";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import "./color.picker.scss";

const colors = [
  { value: null, label: "None" },
  { value: "#F6CE27", label: "Yellow" },
  { value: "#FF8400", label: "Orange" },
  { value: "#FF907E", label: "Pink" },
  { value: "#D012D0", label: "Magenta" },
  { value: "#D12D00", label: "Red" },
  { value: "#6F202B", label: "Cherry" },
  { value: "#CDDB00", label: "Green" },
  { value: "#617A38", label: "Olive" },
  { value: "#C5D9E7", label: "Light Blue" },
  { value: "#089DD4", label: "Teal" },
  { value: "#3776C2", label: "Blue" },
  { value: "#7A45C1", label: "Purple" },
  { value: "#9A9A9A", label: "Gray" },
  { value: "#1D252C", label: "Black" },
];

export const ColorPicker = ({ value, onChange, className }) => {
  return (
    <Dropdown
      className={clsx("color-picker", className)}
      onOptionSelected={(color) => onChange(color)}
      selected={value}
    >
      <DropdownButton>
        <ColorSwatch color={value} />
      </DropdownButton>
      <DropdownItems>
        {colors.map((color, i) => (
          <DropdownItem
            key={`color-${i}-${color.value ?? "none"}`}
            value={color.value}
          >
            <TextTooltip text={color.label}>
              <ColorSwatch color={color.value} />
            </TextTooltip>
          </DropdownItem>
        ))}
      </DropdownItems>
    </Dropdown>
  );
};
